export const CURRENT_LOCATION_STRING = "Current Location";